import { Component, OnInit, Injectable } from '@angular/core';
import { AssetsService } from '../../../shared/services/assets.service';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { UrlService } from '../../../shared/services/url.service';

@Component({
  selector: 'app-assetsFilter',
  templateUrl: '../templates/assetsFilter.component.html'
})

@Injectable()
export class AssetsFilterComponent implements OnInit {

  title = 'AssetsFilter';
  Assets = [];
  Providers = [];
  isActive = true;
  CreateUrl = '';
  EditUrl = '';
  DashboardUrl = '';
  selectedName = '';
  selectedProvider = '';
  selectedTypeDescription = '';
  isFollow = '';
  selectedProviderCode = '';
  dashboardUrl: string;

  constructor(
    private assetsService: AssetsService,
    private alertService: AlertService,
    private urlService: UrlService) {
  }

  ngOnInit() {
    this.Init();
  }

  Init(): void {
    this.initProviders();
    this.DashboardUrl = this.urlService.GetDashboardRoute();
  };

  Filter(): void {
    this.alertService.removeAll();
    this.Assets = [];
    const assetsFilter: Object = this.getFilterRequest();
    this.assetsService.GetByFilter(assetsFilter).subscribe(assets => this.Assets = assets.Assets);
  };

  initProviders(): void {
    this.assetsService.GetProviders().subscribe(providers => this.Providers = providers);
  };

  getFilterRequest(): Object {
    return {
      name: this.selectedName,
      providerId: this.selectedProvider,
      type: this.selectedTypeDescription,
      isFollow: this.isFollow,
      providerCode: this.selectedProviderCode
    };
  };
}



// WEBPACK FOOTER //
// ./src/app/assets/components/scripts/assetsFilter.component.ts